import React from 'react';

import ActivitiesCard from './card';
import Comments from '../comments';

import './styles.scss';

export default function ActivitiesTab() {
  return (
    <div className="deal-activities-tab d-flex">
      <ActivitiesCard/>
      <Comments/>
    </div>
  );
}
